export enum Temperature {
  Celsius = 'celsius',
  Fahrenheit = 'fahrenheit',
}
